import React from "react";

import './App.scss';

var DEFAULT_SITE = "https://www.svoboda.org/"

class RedirButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {url: ""};
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        var source = document.getElementById("url").value;
        if (source.length == 0) source = DEFAULT_SITE;
        var base = "https://s3.amazonaws.com/anynews/r.html#";
        var finalMirror = base + source;
        document.getElementById("urlmirror").value = finalMirror;
        if (navigator.clipboard.writeText) navigator.clipboard.writeText(finalMirror);
    }

    render() {
        return (<button onClick={this.handleClick} className="btn btn-info">
                Redir
            </button>);
    }
}

class MirrorButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {url: ""};

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick() {
        var source = document.getElementById("url").value;
        if (source.length == 0) source = DEFAULT_SITE;
        try {
            const response = await fetch("https://api.duplica.news/api/v1/link?url=" + encodeURIComponent(source) + "&type=live");
            const data = await response.json();
            const finalMirror = data.url;
            document.getElementById("urlmirror").value = finalMirror
            if (navigator.clipboard.writeText) navigator.clipboard.writeText(finalMirror)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    render() {
        return (<button onClick={this.handleClick} className="btn btn-success">
                Mirror
            </button>);
    }
}

function App() {
    return (<>
            <header className="header-logo">
                <img alt="Bypass Censorship" src="logo.png"/>
            </header>
            <main className="bg-dark">
                <div className="container">
                    <div className="row">
                        <p className="text-light"><h1>Bypass Censorship Link Generator</h1></p>
                        <p className="text-light">Enter a URL in the box below, and click
                            <span className="badge bg-info m-1">Redir</span>
                            for a smart redirector link or
                            <span className="badge bg-success m-1">Mirror</span>
                            for a direct mirror link:
                        </p>
                        <div className="search-box">
                            <div className="input-group">
                                <input type="text" placeholder={DEFAULT_SITE} id="url" autoComplete="off"
                                       className="form-control"/>
                                <RedirButton/>
                                <MirrorButton/>
                            </div>

                            <div className="input-group"><br/><br/></div>
                            <div className="input-group">
                                <input type="text"
                                       placeholder="mirror url will be displayed here and copied to clipboard"
                                       id="urlmirror" readonly className="form-control"/>
                            </div>

                        </div>
                    </div>
                    <div className="row pt-5">
                        <div className="col text-light">
                            <h5>About Redirector and Mirrors</h5>
                            <p>
                                These can be accessed through a normal web browser. They use frequently changing URLs
                                to evade censorship. The Redirector links are very difficult to block, and will find a
                                working Mirror for the user at the time they click on the link. The Mirror links are
                                simpler, and take the user directly to a mirror, but will have a limited lifetime as,
                                once discovered, they can be blocked by censors.
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </>);
}

export default App;
